export const baseUrl = 'https://my-json-server.typicode.com/Tekie79/nucampsite/';
export const imgUrl = 'https://nucamp.s3.amazonaws.com/images/';
